import React from 'react'
import './footer.css'
import {FaFacebookF} from 'react-icons/fa'
import {FaInstagram} from 'react-icons/fa'
import {FiTwitter} from 'react-icons/fi'
import {AiFillLinkedin} from 'react-icons/ai'

function footer() {
  return (
   <footer>
    <a href="# home" className='footer_logo'> MH ABRAR</a>

    <ul className="permalinks">
      <li><a href="#header">Home</a></li>
      <li><a href="#about">About</a></li>
      <li><a href="#experience">Experience</a></li>
      <li><a href="#project">Project</a></li>
      <li><a href="#contact">Contact</a></li>
     
    </ul>
    <div className="footer_socials">
      <a href="https://www.facebook.com/profile.php?id=100028152125627"><FaFacebookF/></a>
      <a href="https://www.instagram.com/mhabrar7"><FaInstagram/></a>
      <a href="https://twitter.com/MhAbrar13"><FiTwitter/></a>
      <a href="https://linkedin.com/in/mh-abrar-bb7011228"><AiFillLinkedin/></a>


    </div>
    <div className="footer_copyright">
      <small>&copy; MH ABRAR. All rights reserved.</small>

    </div>



   </footer>
  )
}

export default footer